<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label for="showRating" style="margin-bottom: 0" class="label-input">Rating</label>
            <input type="checkbox" v-model="fields['card-rated-row']" id="showRating" />
          </div>
          <v-row>
            <v-col cols="12" md="4">
              <!-- <v-text-field v-model="fields['rating-stars']" label="Number" type="number" /> -->
              <v-rating
                color="warning"
                background-color="#c1c1c1"
                empty-icon="mdi-star-outline"
                full-icon="mdi-star"
                half-icon="mdi-star-half-full"
                hover
                length="5"
                size="35"
                :value="fields['rating-stars']"
                @input="handleChangeRatingStars"
              ></v-rating>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields['rating-text']" label="Text" />
            </v-col>
          </v-row>
        </div>
        <div style="margin-bottom: 20px">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input">Content</label>
            <!-- <v-checkbox v-model="fields['style-center-y']" label="Style center Y" /> -->
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <input type="checkbox" v-model="fields['style-center-y']" id="style-center-y" />
              <label for="style-center-y" style="margin-bottom: 0">Style center Y</label>
            </div>
          </div>
          <div class="mb-5 wrap-title-card">
            <!-- <v-text-field v-model="fields['card-title']" label="Title" /> -->
            <label>Title</label>
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
          </div>
          <label class="">Description</label>
          <ckeditor :editor="editor" v-model="fields['card-description']" :config="editorConfig" />
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <div style="margin-bottom: 20px">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="text-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['text-color']"
                  @change="handleChangeTextColor"
                />
                <v-text-field v-model="fields['text-color']" label="Text Color" />
                <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div style="margin-bottom: 20px">
              <div>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="head"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-container']"
                    @change="handleChangeCardContainer"
                  />
                  <v-text-field v-model="fields['card-container']" label="Background Color" />
                  <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label for="showBtn" style="margin-bottom: 0" class="label-input">Accordions</label>
              <input type="checkbox" v-model="fields['accordions']['show']" id="showBtn" />
            </div>
            <v-btn small text color="primary" @click="handleAddAccordion">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Accordion</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['accordions']['listItem']" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Accordion {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveAccordion(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="">
                  <div>
                    <v-text-field v-model="item.title" label="Title" />
                  </div>
                  <div>
                    <v-textarea v-model="item.content" label="Content" />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <div>
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label for="showBtn" style="margin-bottom: 0" class="label-input">Button</label>
            <input type="checkbox" v-model="fields['card-btn-row']" id="showBtn" />
          </div>
          <div class="wrap-label">
            <v-text-field v-model="fields['card-btn']['text']" label="Button Text" />
            <v-text-field v-model="fields['card-btn']['url']" label="Button URL" />

            <v-row>
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="button-bg"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['card-btn']['background']"
                      @change="handleChangeButtonBackground"
                    />
                    <v-text-field v-model="fields['card-btn']['background']" label="Button Background Color" />
                    <v-btn @click="handleResetButtonBackground" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="button-text"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['card-btn']['color']"
                      @change="handleChangeButtonTextColor"
                    />
                    <v-text-field v-model="fields['card-btn']['color']" label="Button Text Color" />
                    <v-btn @click="handleResetButtonTextColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-text-field v-model="fields['sub-btn']" label="Sub Button" />
          </div>
        </div>

        <div>
          <label class="label-input">Image</label>
          <v-select
            :value="fields['card-item-image']"
            :items="postionOptions"
            label="Position"
            @change="handleChangePosition"
          />
          <div>
            <UploadImage
              @callback="handleUploadImage"
              :image="{ imageSrc: fields['card-image'] }"
              :height="`250`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveUpload"
            />
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

export default {
  name: 'CardAccordions',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      postionOptions: [
        {
          text: 'Left',
          value: 1,
        },
        {
          text: 'Right',
          value: 2,
        },
      ],
      fields: {
        accordions: {
          show: false,
          listItem: [
            // {
            //   title: '',
            //   content: '',
            // },
          ],
        },
        'card-container': '#fff',
        'card-item-content': 1,
        'card-item-image': 2,
        'card-btn-row': false,
        'card-rated-row': false,
        'card-btn': {
          text: '',
          url: '',
          background: '#2d3436',
          color: '#ffffff',
        },
        'card-content': '',
        'card-image': '',
        'sub-btn': '',
        'rating-stars': 5,
        'rating-text': '',
        //
        'card-title': '',
        'card-description': '',
        'card-survay': false,
        'items-survay': [
          {
            percent: 0,
            description: '',
          },
        ],
        'container-page': {
          'show-style': false,
          background: '#fff',
          'text-color': '',
        },
        'style-center-y': false,
        'text-color': '',
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardAccordions(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields['card-image'] = obj.imageSrc;
    },
    handleRemoveUpload() {
      this.fields['card-image'] = '';
    },
    handleChangePosition(value) {
      this.fields['card-item-image'] = Number(value);
      if (value === 1) {
        this.fields['card-item-content'] = 2;
      } else {
        this.fields['card-item-content'] = 1;
      }
    },
    handleRemoveSurvey(index) {
      this.fields['items-survay'].splice(index, 1);
    },
    handleAddSurvey() {
      this.fields['items-survay'].push({
        percent: 80,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.',
      });
    },
    handleChangeCardContainer(event) {
      this.fields['card-container'] = event.target.value;
    },
    handleChangeContainerBackground(event) {
      this.fields['container-page']['background'] = event.target.value;
    },
    handleChangeContainerTextColor(event) {
      this.fields['container-page']['text-color'] = event.target.value;
    },
    handleChangeRatingStars(value) {
      const num = Number(value);
      this.fields['rating-stars'] = num;
      this.fields['rating-text'] = this.changeTextReting(num, this.fields['rating-text']);
    },
    changeTextReting(value, text = 'Rated 4.9/5 by 12,000+ happy pet owners') {
      return text.replace(/\d+(\.\d+)?\/5/, `${value}/5`);
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleChangeButtonBackground(event) {
      this.fields['card-btn']['background'] = event.target.value;
    },
    handleChangeButtonTextColor(event) {
      this.fields['card-btn']['color'] = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['card-container'] = '#EBE6E2';
    },
    handleResetTextColor() {
      this.fields['text-color'] = '';
    },
    handleResetContainerBackground() {
      this.fields['container-page']['background'] = '#FFFFFF';
    },
    handleResetButtonBackground() {
      this.fields['card-btn']['background'] = '#2d3436';
    },
    handleResetButtonTextColor() {
      this.fields['card-btn']['color'] = '#FFFFFF';
    },
    handleAddAccordion() {
      this.fields['accordions']['listItem'].push({
        title: 'Accordion Title',
        content: 'Accordion Content',
      });
    },
    handleRemoveAccordion(index) {
      this.fields['accordions']['listItem'].splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap-label {
  padding: 10px;
  border-radius: 10px;
  border: solid 1px #c1c1c1;
  margin-bottom: 20px;
}
.wrap-title-card {
  .ck-editor__editable_inline {
    min-height: 150px;
  }
  .ck-editor__editable {
    min-height: 150px;
  }
}
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  //   border-bottom: 1px dashed #0081c7;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  //   border-top: 1px solid #0081c7;
  box-shadow: 0px 0px 12px #0000000f;
}
.v-color-picker__controls {
  padding-bottom: 11px;
}
.v-expansion-panels {
  border: 1px solid #c1c1c1;
  // border-radius: 10px;
  // overflow: hidden;
}
.v-expansion-panel::before {
  box-shadow: none;
}
</style>
